import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Card } from './card';

export const DetailCard = ({ children }: { children?: ReactNode }) => {
  return (
    <Card
      shadow='heavy'
      radius='medium'
      fullWidth
      css={css`
        margin: ${theme.spacing(3, 0)};
        min-width: 660px;
      `}
      as='section'
    >
      {children}
    </Card>
  );
};
